import React, { useState, useEffect } from "react";
import axios from "axios";

import cogniLogo from "../../images/cogni_logo.png";
import SuccessImage from "../../images/success.png";
import "./signup.css";

let currentTimer = undefined;

export const SignUpSuccess = props => {
  const [timer, setTimer] = useState({ show: false, timer: 179 });

  const [invalidEmail, setEmailAsInvalid] = useState({ show: false, msg: "" });

  const startTimer = () => {
    currentTimer = setInterval(() => {
      setTimer({ show: true, timer: timer.timer-- });
    }, 1000);
  };

  const reSend = email => {
    return axios
      .post(process.env.REACT_APP_AUTH_SIGNUP_URL || "/users/send_sign_up", {
        email
      })
      .then(startTimer)
      .catch(err => {
        if (err.response.status === 400) {
          if (
            err.response.data.user_already_exists ||
            err.response.data.attemptOver
          ) {
            setEmailAsInvalid({ show: true, msg: err.response.data.message });
          }
        }
      });
  };

  useEffect(() => {
    if (timer.timer === 0) {
      clearIntervals();
      setTimer({ show: false, timer: 179 });
    }
  }, [timer.timer]);

  const clearIntervals = () => currentTimer && clearInterval(currentTimer);

  return (
    <span className="signup">
      <div className="success_login_bg_height">
        <div className="success_login_bg_width">
          <div className="row">
            <div className="col-md-12 col-lg-12 success_login_bg_width_left">
              <img
                className="centerImage"
                src={cogniLogo}
                alt="Assistant"
                title="Assistant"
              />
              <h2><span className="email_up">Check your inbox to finish signup</span></h2>
              <p>
                Check your email to finish signing up. We sent a signup link to
                you at:
              </p>
              <h4>{props.email}</h4>
              <div className="success_left_bottom_img">
                <img
                  src={SuccessImage}
                  align="middle"
                  alt="Login_img"
                  title="Login_img"
                />
              </div>
              <h6>
                Didn’t get the signup link?{" "}
                <span
                  className={
                    !timer.show && !invalidEmail.show
                      ? ""
                      : "workspace_button_opacity"
                  }
                  onClick={() => reSend(props.email)}
                >
                  Resend it
                </span>
                {timer.show && (
                  <span style={{ color: "#494949", paddingLeft: 5 }}>
                    {"0" + Math.floor(timer.timer / 60)} :{" "}
                    {timer.timer % 60 < 10
                      ? "0" + (timer.timer % 60)
                      : timer.timer % 60}{" "}
                  </span>
                )}
              </h6>
              {invalidEmail.show && (
                <p style={{ color: "#ff7900" }}>{invalidEmail.msg}</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </span>
  );
};
